import { render, staticRenderFns } from "./usermsg.vue?vue&type=template&id=24a1b213&"
import script from "./usermsg.vue?vue&type=script&lang=js&"
export * from "./usermsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports